// Server-side persistence for look & feel (theme, Zen landscape + scenery).
//
// These preferences live in localStorage first and always have — that is what
// keeps the theme applied before first paint, and what makes them work at all
// for a signed-out visitor. The server copy (user_settings.color_theme /
// zen_landscape / zen_scenery, written by PATCH /settings/appearance) exists so
// a signed-in member's choice survives a new browser or a second device.
//
// PRECEDENCE: localStorage wins over the server value whenever it has one.
//
// That ordering needs no timestamps to be correct. On a device the member has
// used, localStorage was written at the same moment as the server copy, so it is
// never staler. On a device they have not used, localStorage is empty and the
// server copy is the only thing there is. The server value is a seed, not an
// authority — which also means a failed or slow PATCH never fights the UI.

import { csrfToken } from "./utils/csrf"

const meta = (name) => {
    const el = document.querySelector(`meta[name='${name}']`)
    const value = el ? el.getAttribute("content") : null
    return value && value.length ? value : null
}

export const serverColorTheme = () => meta("pref-color-theme")
export const serverZenLandscape = () => meta("pref-zen-landscape")
export const serverZenScenery = () => meta("pref-zen-scenery")

// Whether this page belongs to a signed-in member. The metas are only rendered
// then, so their container tells us whether persisting is worth a request at all.
export const canPersistAppearance = () => !!document.querySelector("meta[name='pref-appearance']")

// Fire-and-forget. The caller has already applied the change locally, so there
// is nothing to await and nothing useful to do about a failure: the next change
// will try again, and localStorage is already correct on this device either way.
export const persistAppearance = (attrs) => {
    if (!canPersistAppearance()) return

    const body = {}
    Object.entries(attrs).forEach(([key, value]) => {
        if (value !== null && value !== undefined) body[key] = value
    })
    if (!Object.keys(body).length) return

    fetch("/settings/appearance", {
        method: "PATCH",
        headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": csrfToken()
        },
        body: JSON.stringify({ user_setting: body }),
        keepalive: true
    }).catch(() => {})
}
